// Types
import { TBookmarkOnDTO } from "Types";

export class BookmarkLogic {
    public isResultBookmarked(coworkerBookmarkOn?: TBookmarkOnDTO[], scoutBookmarkOn?: TBookmarkOnDTO[]): boolean {
        if (!coworkerBookmarkOn) coworkerBookmarkOn = [];
        if (!scoutBookmarkOn) scoutBookmarkOn = [];

        const bookmarkOn: TBookmarkOnDTO[] = [...coworkerBookmarkOn, ...scoutBookmarkOn];

        for (const bookmark of bookmarkOn) {
            if (bookmark.isBookmarkedOn) return true;
        }

        return false;
    }
}

export const BookmarkLogicSingleton = new BookmarkLogic();